// extracted by mini-css-extract-plugin
module.exports = {"root":"FlatfyCopyright_root__3h-TN"};
    if(module.hot) {
      // 1586964018404
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  